/**
 * Keystone Product Options calls native form.submit() after injecting line item
 * properties. That bypasses the theme ProductForm AJAX handler and redirects to
 * /cart. Intercept those submits and use the same cart/add.js flow as the theme.
 */
(function () {
  const settings = window.theme && window.theme.settings;

  if (!settings || settings.cartType !== 'drawer' || !settings.openDrawerOnAddToCart) {
    return;
  }

  const nativeFormSubmit = HTMLFormElement.prototype.submit;
  let inFlight = false;

  function hasKeystoneBlock() {
    return Boolean(document.getElementById('key_options_block'));
  }

  function isProductAddToCartForm(form) {
    const action = (form.getAttribute('action') || '').toLowerCase();

    if (!action.includes('/cart/add')) {
      return false;
    }

    return (
      form.hasAttribute('data-product-form') ||
      Boolean(form.closest('[data-product-root]')) ||
      Boolean(form.querySelector('[name="id"]'))
    );
  }

  function getFormContext(form) {
    return (
      form.closest('[x-data="ProductForm"]') ||
      form.closest('data-island') ||
      form.closest('[data-product-root]') ||
      form
    );
  }

  function dispatchProductFormEvent(target, name, detail) {
    target.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        ...(detail ? { detail } : {}),
      })
    );
  }

  async function ajaxAddToCart(form) {
    if (inFlight) {
      return;
    }

    inFlight = true;

    const formData = new FormData(form);
    const formId = form.getAttribute('id');
    const contextEl = getFormContext(form);

    formData.append('sections', 'cart-items,cart-footer,cart-item-count');
    formData.append('sections_url', window.location.pathname);

    dispatchProductFormEvent(contextEl, 'baseline:productform:loading');

    try {
      const response = await fetch(window.theme.routes.cart_add_url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: formData,
      });

      const data = await response.json();

      if (data && data.status) {
        const errorDetail = {
          sourceId: formId,
          variantId: Number(formData.get('id')),
          errors: data.errors || data.description,
          message: data.description || data.message || null,
        };

        dispatchProductFormEvent(
          contextEl,
          'baseline:productform:error',
          errorDetail
        );

        document.dispatchEvent(
          new CustomEvent('theme:product:error:add-to-cart', {
            detail: {
              productRootEl: form.closest('[data-product-root]'),
              formEl: form,
              ...errorDetail,
            },
          })
        );

        return;
      }

      dispatchProductFormEvent(contextEl, 'baseline:productform:success');

      document.body.dispatchEvent(
        new CustomEvent('baseline:cart:afteradditem', {
          bubbles: true,
          detail: {
            response: data,
            sourceId: formId,
          },
        })
      );
    } catch (error) {
      const errorDetail = {
        sourceId: formId,
        variantId: Number(formData.get('id')),
        errors: error,
        message: window.theme.strings.cartError,
      };

      dispatchProductFormEvent(
        contextEl,
        'baseline:productform:error',
        errorDetail
      );

      document.dispatchEvent(
        new CustomEvent('theme:product:error:add-to-cart', {
          detail: {
            productRootEl: form.closest('[data-product-root]'),
            formEl: form,
            ...errorDetail,
          },
        })
      );
    } finally {
      inFlight = false;
    }
  }

  HTMLFormElement.prototype.submit = function submitWithKeystoneBridge() {
    if (hasKeystoneBlock() && isProductAddToCartForm(this)) {
      void ajaxAddToCart(this);
      return;
    }

    nativeFormSubmit.call(this);
  };
})();
